var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgReturn = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 19,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#9B9B9B",
  d: "M13.85 6.5c1.122 0 2.399 1.177 2.399 3.125s-1.277 3.125-2.399 3.125H1.654v2.5H13.85c2.909 0 4.899-2.74 4.899-5.625S16.759 4 13.85 4H6.586V.698L.387 5.25l6.2 4.552V6.5z"
})));
export { SvgReturn as ReactComponent };
export default "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJzdGF0aWMvbWVkaWEvcmV0dXJuLmU1NDY1OWE0LnN2ZyI7";